// eslint-disable-next-line no-unused-vars
import * as React from "react";
import { MenuItem as MuiMenuItem, styled } from "@mui/material";

export const MenuItem = styled(MuiMenuItem)(
    ({ theme }) => `
    margin: 4px 0;
  
    &.Mui-selected { 
        border-right: 4px solid ${theme.palette.primary.main}; 
    }
  `,
);